module.exports = __webpack_public_path__ + "img/wavicle.8cd5f22a.svg";